import React, {Component} from "react";

export default class LoadingButton extends Component {

	constructor(props) {
		super(props);
		this.state = {isLoading: false};
		this._mounted = false;
	}

	componentDidMount() {
		this._mounted = true;
	}

	componentWillUnmount() {
		this._mounted = false;
	}

	handleClick = (e) => {
		const isLoading = this.props.loading !== undefined ? this.props.loading : this.state.isLoading;

		if (isLoading) {
			e.preventDefault();
			e.stopPropagation();
			return;
		}

		const {onClick} = this.props;
		if (!onClick) return;

		const result = onClick(e);

		if (result && typeof result.then === 'function') {
			this.setState({isLoading: true});
			const cleanup = () => {
				if (this._mounted) {
					this.setState({isLoading: false});
				}
			};
			result.then(cleanup, cleanup);
		}
	};

	render() {
		const {className, children, type, disabled, loading} = this.props;
		const isLoading = loading !== undefined ? loading : this.state.isLoading;

		return (
			<button
				type={type || 'button'}
				className={className}
				onClick={this.handleClick}
				disabled={isLoading || disabled}
			>
				{isLoading ? <span className="btn-spinner"/> : children}
			</button>
		);
	}
}
